import React, { Component, PropTypes } from 'react';
import { getSiteName, getSitePhone } from '../../../utils/url';
import GenericError from '../GenericError';


class HttpErrorsRedirect extends Component {
  constructor(props) {
    super(props);
  }

  /*componentWillMount() {
    const { router } = this.context;
    router.push('/');
  }*/

  handleErrorWindowAction = () => {
    console.log('handle error window close');
    const { router } = this.context;
    router.push('/');
  };

  render() {
    let errorStatus = 'Generic';
    if (this.props.location.state) errorStatus = this.props.location.state.status;

    const headingText = `Error ${errorStatus}!`;
    const statusobj = {
      icon: 'error',
      value: 999,
      name: 'error',
      label: 'Sorry what you are looking for cannot be found!'
    };
    const messageDetail = `Try it again, and if it still doesn't work please contact ${getSiteName()} on ${getSitePhone()}`;

    const actionHandler = {
      label: ' Go back ',
      action: this.handleErrorWindowAction
    };

    return (
      <GenericError
        headindText={headingText}
        messageDetail={messageDetail}
        formattedErrorStatus={statusobj}
        actionHandler={actionHandler}
      />
    );
  }
}

HttpErrorsRedirect.propTypes = {
  errorObj: React.PropTypes.object
};

HttpErrorsRedirect.contextTypes = {
  router: PropTypes.object
};

export default HttpErrorsRedirect;



// WEBPACK FOOTER //
// ./src/features/errors/httpErrors/HttpErrorsRedirect.js